import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  Switch,
  FormControlLabel,
  FormControl,
  OutlinedInput,
  FormGroup,
  MenuItem,
  InputLabel,
  Select,
  Box,
  Chip,
  Button,
} from "@material-ui/core";
import "./create-list.css";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { getFamily } from "../api-interactions/family";
import { getCookie } from "../helperFunctions/cookie";
import { createList } from "../api-interactions/lists";
import { useNavigate } from "react-router-dom";

export const CreateList = (props) => {
  const [memberName, setMemberName] = useState([]);
  const [memberCanAdd, setMemberCanAdd] = useState(true);
  const [members, setMembers] = useState([]);
  const [publicList, setPublicList] = useState(true);
  const [needPermissionToAdd, setNeedPermissionToAdd] = useState(false);
  const [membersCanGetPoints, setMembersCanGetPoints] = useState(true);
  const listTitleRef = useRef();
  const listDescriptionRef = useRef();
  const excludedMembersRef = useRef();
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const jwt = getCookie();

  useEffect(() => {
    (async function () {
      const members = await getFamily(user);
      setMembers(members);
    })();
  }, []);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setMemberName(typeof value === "string" ? value.split(",") : value);
  };

  const changeRadio = (e) => {
    switch (e.target.id) {
      case "publicList":
        setPublicList((prevState) => {
          return !prevState;
        });
        break;
      case "memberCanAdd":
        setMemberCanAdd((prevState) => {
          return !prevState;
        });
        break;
      case "needPermissionToAdd":
        setNeedPermissionToAdd((prevState) => {
          return !prevState;
        });
        break;
      case "membersCanGetPoints":
        setMembersCanGetPoints((prevState) => {
          return !prevState;
        });
        break;
      default:
        break;
    }
  };

  const createListHandler = async (e) => {
    e.preventDefault();
    const exclude = excludedMembersRef.current.value;
    let includedMembersArray = [user._id];

    if (publicList) {
      const includedMembers = members.filter(function (obj) {
        return !exclude.includes(obj.userName);
      });
      includedMembersArray = [];
      includedMembers.map((item) => {
        includedMembersArray.push(item.userId); // To transform the array of objects into a string array
      });
    }
    const newList = {
      owner: user.email,
      canSee: includedMembersArray,
      addBtn: memberCanAdd,
      public: publicList,
      title: listTitleRef.current.value,
      description: listDescriptionRef.current.value,
      needPermission: needPermissionToAdd,
      points: membersCanGetPoints,
    };
    const responseList = await createList(jwt, newList);
    navigate("/dashboard/lists/" + responseList._id);
  };

  return (
    <div id="create-list-container">
      <div id="create-list-heading">
        <IoIosCloseCircleOutline
          id="create-list-close"
          onClick={() => {
            props.setCreateList(false);
          }}
        />
        <h2 id="create-list-headline">Create List</h2>
      </div>
      <form id="create-list-content">
        <div id="column-1">
          <TextField label="Title*" inputRef={listTitleRef} />
          <TextField
            inputRef={listDescriptionRef}
            label="Description*"
            multiline
            rows={4}
            variant="outlined"
          />
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  id="publicList"
                  onChange={changeRadio}
                  defaultChecked
                  color="primary"
                />
              }
              label="Public"
            />
          </FormGroup>
          <FormControl
            id="excludeMembersDropdownContainer"
            sx={{ m: 2, width: 300, heigth: 200 }}
          >
            <InputLabel id="demo-multiple-chip-label">
              Exclude members?
            </InputLabel>
            <Select
              inputRef={excludedMembersRef}
              labelId="demo-multiple-chip-label"
              id="demo-multiple-chip"
              multiple
              value={memberName}
              onChange={handleChange}
              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
              renderValue={(selected) => (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </Box>
              )}
              MenuProps={MenuProps}
            >
              {members.map((member) => (
                <MenuItem key={member.userName} value={member.userName}>
                  {member.userName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div id="column-2">
          <h3 className="create-list-checkbox-title">
            Family members can add items
          </h3>
          <Switch
            onChange={changeRadio}
            id="memberCanAdd"
            defaultChecked
            color="primary"
          />

          {memberCanAdd && (
            <>
              <h3 className="create-list-checkbox-title">
                You have to first accept the items
              </h3>
              <Switch
                onChange={changeRadio}
                id="needPermissionToAdd"
                color="primary"
              />
            </>
          )}
          <br />
          <br />
          <h3 className="create-list-checkbox-title">
            Members can get points in this list
          </h3>
          <Switch
            onChange={changeRadio}
            id="membersCanGetPoints"
            defaultChecked
            color="primary"
          />
          <br />
          <Button
            type="submit"
            id="create-list-btn"
            onClick={createListHandler}
            variant="contained"
            color="primary"
          >
            Create List
          </Button>
        </div>
      </form>
      <svg
        className="not-700px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
        id="wave"
      >
        <path d="M0,32L80,58.7C160,85,320,139,480,176C640,213,800,235,960,229.3C1120,224,1280,192,1360,176L1440,160L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
      </svg>
      <svg className="not-700px" id="blob" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M54.4,-66.2C66.8,-54.5,70.4,-33.8,72.9,-13.8C75.3,6.3,76.5,25.6,69.2,41.7C62,57.8,46.2,70.7,29.2,74.4C12.1,78.2,-6.2,72.8,-19,63.3C-31.7,53.8,-38.9,40.2,-47.2,26.7C-55.6,13.3,-65.1,0.1,-62.2,-10C-59.3,-20.1,-43.9,-27.1,-31.5,-38.8C-19,-50.5,-9.5,-66.9,5.8,-73.8C21,-80.6,42.1,-77.9,54.4,-66.2Z"
          transform="translate(100 100)"
        />
      </svg>
    </div>
  );
};
